import React from 'react'
import { observer } from 'mobx-react'

@observer
class FilmEvaluation extends React.Component {

  _attr (name, e) {
    const attrs = e.get('attrs')
    if (attrs) {
      let found = attrs.find((atr) => {
        return atr.platform === 'common' && atr.name === name
      })
      return found ? found.value : undefined
    }
  }

  render () {
    const { entity, store } = this.props

    return (
      <div>
        <h5 className="card-title">Evaluation</h5>
        <div className="table-responsive"><table className='table table-hover table-striped table-condensed'>
          <thead>
            <tr>
              <th>
                Atribute name
              </th>
              <th>
                Value
              </th>
              <th>
                Atribute name
              </th>
              <th>
                Value
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                IMDB Rating
              </td>
              <td>
                {this._attr('imdbRating', entity)}
              </td>
              <td>
                IMDB Votes
              </td>
              <td>
                {this._attr('imdbVotes', entity)}
              </td>
            </tr>
            <tr>
              <td>
                Year (test)
              </td>
              <td>
                {this._attr('year', entity)}
              </td>
              <td>
                IMDB votes
              </td>
              <td>
                {this._attr('imdbVotes', entity)}
              </td>
            </tr>
            <tr>
              <td>
                Metascore
              </td>
              <td>
                {this._attr('metascore', entity)}
              </td>
              <td>
                BoxOffice
              </td>
              <td>
                {this._attr('boxOffice', entity)}
              </td>
            </tr>
            <tr>
              <td>
                TomatoImage
              </td>
              <td>
                {this._attr('tomatoImage', entity)}
              </td>
              <td>
                TomatoRating
              </td>
              <td>
                {this._attr('tomatoRating', entity)}
              </td>
            </tr>
            <tr>
              <td>
                TomatoReviews
              </td>
              <td>
                {this._attr('tomatoReviews', entity)}
              </td>
              <td>
                TomatoUserMeter
              </td>
              <td>
                {this._attr('tomatoUserMeter', entity)}
              </td>
            </tr>
            <tr>
              <td>
                TomatoFresh
              </td>
              <td>
                {this._attr('tomatoFresh', entity)}
              </td>
              <td>
                TomatoRotten
              </td>
              <td>
                {this._attr('tomatoRotten', entity)}
              </td>
            </tr>
            <tr>
              <td>
                TomatoUserRating
              </td>
              <td>
                {this._attr('tomatoUserRating', entity)}
              </td>
              <td>
                TomatoUserReviews
              </td>
              <td>
                {this._attr('tomatoUserReviews', entity)}
              </td>
            </tr>
          </tbody>
        </table>
        <table className='table table-hover table-striped table-condensed'>
          <tbody>
            <tr>
              <td>
                Awards
              </td>
              <td>
                {this._attr('awards', entity)}
              </td>
            </tr>
            <tr>
              <td>
                TomatoConsensus
              </td>
              <td>
                {this._attr('tomatoConsensus', entity)}
              </td>
            </tr>
            <tr>
              <td>
                TomatoURL
              </td>
              <td>
                <a href={this._attr('tomatoURL', entity)}>
                  {this._attr('tomatoURL', entity)}
                </a>
              </td>
            </tr>
          </tbody>
        </table></div>
      </div>
    )
  }
}
export default FilmEvaluation
